package fr.manyverse.app.infrastructure.monitoring

import co.touchlab.kermit.Severity

internal actual fun createCrashReporter(): CrashReporter = BrowserSentryCrashReporter()

/**
 * [CrashReporter] du web : le SDK Kotlin Multiplatform de Sentry n'a pas d'implémentation
 * JS, on s'appuie donc directement sur `@sentry/browser`, qui capte en plus les erreurs
 * globales et les promesses rejetées non gérées.
 */
private class BrowserSentryCrashReporter : CrashReporter {

    override fun start(config: CrashReporterConfig) {
        val options: dynamic = js("({})")
        options.dsn = config.dsn
        options.release = config.release
        options.environment = config.environment
        options.sendDefaultPii = false
        sentryInit(options)
    }

    override fun setUserId(userId: String?) {
        if (userId == null) {
            sentrySetUser(null)
        } else {
            val user: dynamic = js("({})")
            user.id = userId
            sentrySetUser(user)
        }
    }

    // Rien à faire : l'intégration console de @sentry/browser enregistre déjà en breadcrumb
    // chaque ligne que le ConsoleWriter de Kermit écrit dans la console
    override fun addBreadcrumb(severity: Severity, tag: String, message: String) = Unit

    override fun captureException(throwable: Throwable, tag: String, message: String) {
        val databaseTags = throwable.databaseErrorTags()
        val tags: dynamic = js("({})")
        tags[LOG_TAG_KEY] = tag
        databaseTags.forEach { (key, value) -> tags[key] = value }
        val extra: dynamic = js("({})")
        extra[LOG_MESSAGE_KEY] = message
        val captureContext: dynamic = js("({})")
        captureContext.tags = tags
        captureContext.extra = extra
        databaseFingerprint(databaseTags)?.let { captureContext.fingerprint = it.toTypedArray() }
        sentryCaptureException(throwable, captureContext)
    }
}
